<template>
  <div class="basic-info">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form
          class="ant-advanced-search-form"
          layout="inline"
          :form="form"
          @submit="handleSearch"
        >
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item label="产品名称">
                <a-input
                  placeholder="请输入产品名称"
                  v-decorator="['fundName']"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="产品代码">
                <a-input
                  placeholder="请输入产品代码"
                  v-decorator="['fundCode']"
                ></a-input>
              </a-form-item>
            </a-col>
            <template v-if="expand">
              <a-col :md="6" :sm="8">
                <a-form-item label="产品性质">
                  <j-dict-select-tag
                    type="list"
                    :triggerChange="true"
                    dictCode="proNature"
                    placeholder="请选择"
                    v-decorator="['proNature']"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="投资类型">
                  <j-dict-select-tag
                    type="list"
                    :triggerChange="true"
                    dictCode="investType"
                    placeholder="请选择"
                    v-decorator="['investType']"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item label="产品风险">
                  <j-dict-select-tag
                    type="list"
                    :triggerChange="true"
                    dictCode="riskLevel"
                    placeholder="请选择"
                    v-decorator="['riskLevel']"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="是否母产品">
                  <a-select placeholder="请选择" v-decorator="['isParent']">
                    <a-select-option :value="0">否</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <a-form-item label="审核状态">
                  <a-select placeholder="请选择" v-decorator="['isReview']">
                    <a-select-option :value="0">未审核</a-select-option>
                    <a-select-option :value="1">已审核</a-select-option>
                    <a-select-option :value="2">已驳回</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="6" :sm="8">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleSearch" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="handleReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
                <a @click="toggle" style="margin-left: 8px">
                  {{ expand ? '收起' : '展开' }}
                  <a-icon :type="expand ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        <a-button
          type="primary"
          icon="download"
          @click="handleExportExcel('产品基本信息')"
          >导出</a-button
        >

        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />批量删除</a-menu-item
            >
            <a-menu-item key="2" @click="batchManager">
              <a-icon type="delete" />批量分配投资经理</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          size="middle"
          bordered
          :columns="columns"
          :data-source="fundList"
          rowKey="id"
          :scroll="{ x: 1700 }"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          @change="handleTableChange"
        >
          <span slot="fundName" slot-scope="text, record">
            <a @click="handleDetail(record)">{{ text }}</a>
          </span>
          <template slot="fileSlot" slot-scope="text">
            <span v-if="!text" style="font-size: 12px; font-style: italic"
              >无文件</span
            >
            <a-button
              v-else
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="uploadFile(text)"
            >
              下载
            </a-button>
          </template>
          <template slot="shelfStatus" slot-scope="text, record">
            <a-switch
              v-model="record.shelfStatus"
              :disabled="record.isReview == 1 ? false : true"
              checked-children="下架"
              un-checked-children="上架"
              @click="handleShelve(record)"
            />
          </template>
          <span slot="action" slot-scope="text, record">
            <a
              :disabled="record.isReview == '1' ? true : false"
              @click="handleAudit(record)"
              >审核</a
            >

            <a-divider type="vertical" />
            <a @click="handleEdit(record)">编辑</a>

            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item
                  ><a @click="disManager(record)">分配投资经理</a></a-menu-item
                >
                <a-menu-item
                  ><a @click="confirmCopyProduct(record)"
                    >复制产品</a
                  ></a-menu-item
                >
                <a-menu-item
                  ><a
                    @click="handleSubproduct(record)"
                    :class="record.isParent == 0 ? 'disabledCls' : ''"
                    >添加子产品</a
                  ></a-menu-item
                >
                <a-menu-item>
                  <a @click="handleDelete(record.id)">删除</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="reviewModal(record)">预览</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>

      <add-product ref="modalForm" @handleOk="modalFormOk"></add-product>
      <a-modal
        v-model="checkVisible"
        title="审核"
        @cancel="checkVisible == false"
      >
        <template slot="footer">
          <a-button @click="handleReview(2)">审核驳回</a-button>
          <a-button type="primary" @click="handleReview(1)">审核通过</a-button>
        </template>
        <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 14 }">
          <a-form-item label="产品名称">
            <a-input
              placeholder="请输入产品名称"
              v-model="currentProduct.fundName"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="产品代码">
            <a-input
              placeholder="请输入产品代码"
              v-model="currentProduct.fundCode"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="投资类型">
            <a-input
              placeholder="请输入投资类型"
              v-model="currentProduct.investType_dictText"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="产品风险">
            <a-input
              placeholder="请输入产品风险"
              v-model="currentProduct.riskLevel_dictText"
              disabled
            ></a-input>
          </a-form-item>
          <a-form-item label="产品性质">
            <a-input
              placeholder="请输入产品性质"
              v-model="currentProduct.proNature_dictText"
              disabled
            ></a-input>
          </a-form-item>
        </a-form>
      </a-modal>
      <add-manager ref="managerForm"></add-manager>
      <add-sub-product ref="subProductModal"></add-sub-product>
      <a-modal
        title="产品复制"
        :visible="copyModal"
        @ok="handleCopyProduct"
        @cancel="copyModal = false"
      >
        <a-form-item placeholder="请选择目标产品代码" label="目标产品代码">
          <a-input v-model="copyFundCode" :max-length="7"></a-input>
        </a-form-item>
        <p style="font-size: 12px; color: red">
          产品代码复制成功后不可修改，请仔细填写！
        </p>
      </a-modal>
    </a-card>

    <!-- <product-details
      v-if="productDetailsShow"
      @producetStatus="producetStatus"
    ></product-details> -->
  </div>
</template>
<script>
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'; //下拉组件
import customRender from '@/utils/customRender.js';
import addProduct from './addProduct.vue';
import addManager from './addManager.vue';
import addSubProduct from './addSubProduct.vue';
import productDetails from './productDetails.vue';
import { productMessageList } from '@/api/api';
import { postTag, postAction, downFiles, getAction } from '@/api/manage';
import { copyProduct, getManagerList } from '@/api/product';
import Preview from '@/components/common/Preview';
const columns = [
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundName',
    scopedSlots: { customRender: 'fundName' },
    width: 200,
  },
  // { title: '产品规模', align: 'center', dataIndex: 'productScale', width: 100 },
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode',
    width: 150,
  },
  // {
  //   title: '产品状态',
  //   align: 'center',
  //   dataIndex: 'fundState',
  //   width: 150
  // },
  {
    title: '投资类型',
    align: 'center',
    dataIndex: 'investType_dictText',
    width: 150,
  },
  {
    title: '产品风险',
    align: 'center',
    dataIndex: 'riskLevel_dictText',
    width: 150,
  },
  {
    title: '产品性质',
    align: 'center',
    dataIndex: 'proNature_dictText',
    width: 150,
  },
  {
    title: '是否母产品',
    align: 'center',
    dataIndex: 'isParent',
    customRender: (text) => {
      if (text == 0) {
        return '否';
      } else if (text == 1) {
        return '是';
      } else {
        return text;
      }
    },
    width: 150,
  },
  {
    title: '成立日',
    align: 'center',
    dataIndex: 'setupDate',
    width: 150,
    customRender: customRender,
  },
  {
    title: '创建时间',
    align: 'center',
    dataIndex: 'createTime',
    width: 200,
  },
  {
    title: '更新时间',
    align: 'center',
    dataIndex: 'updateTime',
    customRender: customRender,
    width: 200,
  },

  {
    title: '审核状态',
    align: 'center',
    dataIndex: 'isReview',
    customRender: (text) => {
      if (text == 0) {
        return '未审核';
      } else if (text == 1) {
        return '已审核';
      } else if (text == 2) {
        return '已驳回';
      }
    },
    width: 100,
  },
  {
    ellipsis: true,
    align: 'center',
    title: '上架状态',
    dataIndex: 'shelfStatus',
    key: 'shelfStatus',
    width: 100,
    scopedSlots: {
      customRender: 'shelfStatus',
    },
  },

  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  data() {
    return {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      columns,
      expand: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      fundList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      url: {
        add: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/save', //添加
        delete: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/del', //删除
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/del/batch', //批量删除
        auditReview: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/review', //审核
        auditBatch:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/reviewByList',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/excel/export', //导出
        managerByFundCode:
          process.env.VUE_APP_CMS_PRODUCT +
          '/product/relevance/selectListByFundCode',
        shelveFundCode:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/publish',
        batchManager:
          process.env.VUE_APP_CMS_PRODUCT + ' /product/fund/manager/addBatch',
      },
      checkVisible: false, //审核弹窗
      currentProduct: {},
      productDetailsShow: false,
      copyModal: false, //复制产品弹窗
      copyFundCode: '', //复制的新产品code
      producManager: [], //某产品下的已分配的投资经理
      id: '',
      getLinkUrl: process.env.VUE_APP_CMS_CONTENT + '/front/api/preview/info',
    };
  },
  components: {
    JDictSelectTag,
    addProduct,
    addManager,
    addSubProduct,
    productDetails,
    Preview,
  },
  created() {
    this.initFundList();
  },
  methods: {
    batchManager() {
      this.$refs.managerForm.handleVisible('', this.selectedRows);
    },
    producetStatus() {
      this.productDetailsShow = false;
    },
    initFundList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      this.form.validateFields((error, values) => {
        let params = {
          ...values,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize,
        };
        that.loading = true;
        productMessageList(params).then((res) => {
          that.loading = false;
          if (res.success) {
            that.fundList = res.result.records;
            this.fundList.forEach((item, index) => {
              item.shelfStatus = item.status == 1 ? true : false;
              item.key = index + 1;
            });
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      });
    },
    //上下架
    handleShelve(record) {
      console.log(record);
      let strOpen = '确定要上架所选数据?';
      let strClose = '确定要下架所选数据?';
      let data = {
        bannerList: [],
        type: '',
      };
      let status = '';
      if (record.shelfStatus) {
        status = 1;
      } else {
        status = 0;
      }
      let params = {
        status,
        id: record.id,
      };
      var that = this;
      this.$confirm({
        title: record.shelfStatus ? '数据上架' : '数据下架',
        content: record.shelfStatus ? strOpen : strClose,
        onOk() {
          data.type = record.shelfStatus ? '1' : '0';
          postTag(that.url.shelveFundCode, params).then((res) => {
            if (res.success) {
              if (record.shelfStatus) {
                that.$message.success('上架成功!');
              } else {
                that.$message.success('下架成功!');
              }
              that.initFundList();
            } else {
              that.$message.error(res.message);
              record.shelfStatus = !record.shelfStatus;
            }
          });
        },
        onCancel() {
          record.shelfStatus = !record.shelfStatus;
        },
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    handleSearch(e) {
      e.preventDefault();
      this.initFundList(1);
    },
    handleReset() {
      this.form.resetFields();
      this.initFundList(1);
    },
    toggle() {
      this.expand = !this.expand;
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(selectionRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initFundList();
    },
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
    },
    modalFormOk() {
      //新增or编辑后重新刷新列表
      this.initFundList();
    },
    disManager(code) {
      this.$refs.managerForm.handleVisible(code);
      this.$refs.managerForm.fundCode = code.fundCode;
      let that = this;
      that.$refs.managerForm.initManagerByFundCode(this.producManager);
    },
    confirmCopyProduct(record) {
      let that = this;
      that.id = record.id;

      this.$confirm({
        title: '确认复制',
        content: '确定要复制这个产品?',
        onOk: function () {
          that.copyModal = true;
          that.currentProduct = record;
          that.copyFundCode = '';
        },
      });
    },
    handleCopyProduct() {
      let that = this;
      if (that.copyFundCode.length < 6) {
        this.$message.warning('产品代码不能小于6位');
        return;
      }
      let regs = /^[0-9]*$/;
      if (!regs.test(that.copyFundCode)) {
        this.$message.warning('产品代码只能为数字');
        return;
      }
      that.loading = true;
      copyProduct({
        fundCode: that.currentProduct.fundCode,
        newCode: that.copyFundCode,
        id: that.id,
      }).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.initFundList();
          that.onClearSelected();
          that.copyModal = false;
        } else {
          that.$message.error(res.message);
        }
        that.loading = false;
      });
    },
    handleSubproduct(record) {
      //必须该产品本身是母产品才能添加子产品
      if (record.isParent == 0) {
        return;
      }
      this.$refs.subProductModal.handleVisible(record);
      this.$refs.subProductModal.fundCode = record.fundCode;
      console.log(record);
    },
    // 批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.deleteBatch, {
            ids: that.selectedRowKeys.join(','),
          })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.initFundList();
                that.onClearSelected();
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    //查看详情
    handleDetail(record) {
      this.$router.push({
        path: '/product/basicInfo/productDetails',
        query: { fundCode: record.fundCode, fundId: record.id },
      });
    },
    //单条记录删除
    handleDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.initFundList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    getManagerByFundCode(fundCode) {
      //获取产品下投资经理
      let managerData = [];
      getManagerList({ fundCode }).then((res) => {
        if (res.success) {
          managerData = res.result && res.result.list ? res.result.list : [];
          this.producManager = managerData;
        } else {
          this.$message.error('获取投资经理失败！');
        }
      });
      return managerData;
    },
    // 审核
    handleReview(flg) {
      let that = this;
      let param = {
        id: this.currentProduct.id,
        isReview: flg,
        reason: '',
      };
      that.loading = true;
      postTag(that.url.auditReview, param)
        .then((res) => {
          that.checkVisible = false;
          if (res.success) {
            that.initFundList();
            that.$message.success(res.message);
          } else {
            that.$message.error(res.message);
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    handleAudit(record) {
      console.log(record);
      // let arr = this.getManagerByFundCode(record.fundCode);
      // if (arr.length <= 0) {
      //   return this.$message.warning('该产品未分配经理,请先分配经理');
      // } else {
      this.checkVisible = true;
      this.currentProduct = record;
      // }
    },
    //导出excel
    handleExportExcel(fileName) {
      if (this.selectedRows.length <= 0) {
        return this.$message.warning('请选择数据');
      }
      let index = this.selectedRows.findIndex((item) => item.isReview == '0');

      if (index > -1) {
        this.$message.warning('选中的数据当前有未审核的数据,不能导出');
        return;
      } else {
        if (!fileName || typeof fileName != 'string') {
          fileName = '导出文件';
        }
        let param = { ...this.queryParam };
        if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          param['selections'] = this.selectedRowKeys.join(',');
        }
        downFiles(this.url.exportXlsUrl, { fundCode: 'N1234' }).then((data) => {
          if (!data) {
            this.$message.warning('文件下载失败');
            return;
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              new Blob([data], { type: 'application/vnd.ms-excel' }),
              fileName + '.xls'
            );
          } else {
            let url = window.URL.createObjectURL(
              new Blob([data], { type: 'application/vnd.ms-excel' })
            );
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName + '.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
            this.searchQuery();
          }
        });
      }
    },
    reviewModal(record) {
      console.log(record);
      let param = {
        type: 3,
      };
      let urlTemp = `?fundCode=${record.fundCode}&isExpectedPro=${
        record.isExpectedPro
      }&investType=${record.investType}&proNature=${
        record.proNature
      }&showFundCode=${
        record.showFundCode ? record.showFundCode : ''
      }&previewCode=`;
      getAction(this.getLinkUrl, param).then((res) => {
        console.log(res);
        if (res.success) {
          if (res.result) {
            window.open(`${res.result.url}${urlTemp}${res.result.previewCode}`);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ant-advanced-search-form {
  width: 100%;
  background: #fff;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
.table-operator {
  margin-bottom: 10px;
}

.disabledCls {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
</style>
